import { createSelector } from '@ngrx/store';
import { AppState } from '@state/index';
import { DemandState } from './demand.state';

export const selectDemandState = (state: AppState) => state.demand;

export const selectedDemand = createSelector(
  selectDemandState,
  (state: DemandState) => state.demand
);
